module.exports = __webpack_public_path__ + "img/nt107-04-98.prt.115906d6.jpg";